import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = ["dateRange", "customerId", "userId", "projectId"];
  connect() {
    flatpickr("#date_range", { mode: "range", altInput: true });
  }

  updateClientReport() {
    const url = `${window.location.pathname}?date_range=${this.dateRangeTarget.value}`;

    if (this.dateRangeTarget.value.indexOf("to") > -1) {
      Turbo.cache.clear();
      Turbo.visit(url);
    }
  }

  updateReport() {
    var url = "";
    if (this.hasUserIdTarget) {
      url = `${window.location.pathname}?date_range=${this.dateRangeTarget.value}&customer_id=${this.customerIdTarget.value}&user_id=${this.userIdTarget.value}`;
    } else {
      url = `${window.location.pathname}?date_range=${this.dateRangeTarget.value}&customer_id=${this.customerIdTarget.value}`;
    }

    if (this.dateRangeTarget.value.indexOf("to") > -1) {
      Turbo.cache.clear();
      Turbo.visit(url);
    }
  }

  updateTimeLogReport() {
    var url = "";
    if (this.hasUserIdTarget) {
      url = `${window.location.pathname}?date_range=${this.dateRangeTarget.value}&customer_id=${this.customerIdTarget.value}&user_id=${this.userIdTarget.value}&project_id=${this.projectIdTarget.value}`;
    } else {
      url = `${window.location.pathname}?date_range=${this.dateRangeTarget.value}&customer_id=${this.customerIdTarget.value}&project_id=${this.projectId.value}`;
    }

    if (this.dateRangeTarget.value.indexOf("to") > -1) {
      Turbo.cache.clear();
      Turbo.visit(url);
    }
  }
  disconnect() {}
}
